<script lang="tsx" setup>
import { KirbyImageData } from "@/queries/image"

import { KirbyBlock } from "@/queries/blocks"

import StudentGalleryWrapper from "@/components/StudentPage/StudentGalleryWrapper.vue"

const { images } = defineProps<{
  images: KirbyImageData[]
}>()

const galleryBlocks: KirbyBlock<"image">[] = images.map(image => ({
  id: image.id,
  type: "image",
  isHidden: false,
  content: {
    location: "",
    image: [image.uuid],
    src: image.src,
    alt: image.alt,
    caption: image.caption,
    link: "",
    ratio: String(image.ratio),
    crop: false,
  },
}))
</script>

<template>
  <div>
    <StudentGalleryWrapper :blocks="galleryBlocks" />
  </div>
</template>
